export default __webpack_public_path__ + "static/media/1809.49860729.png";